const {ccclass, property} = cc._decorator;

let Direction = cc.Enum({
    HORIZONTAL: 0,
    VERTICAL: 1,
})

let EventType = cc.Enum({			
    SCROLL_TO_TOP: 0,
    SCROLL_TO_BOTTOM: 1,
    SCROLL_TO_LEFT: 2,
    SCROLL_TO_RIGHT: 3,
    SCROLLING: 4,
    SCROLL_ENDED: 5,
    TOUCH_UP: 6,
    SCROLL_BEGAN: 7,		
})

@ccclass
export default class SimpleScrollView extends cc.Component {
    @property(cc.Node)
    content: cc.Node = null

    @property({type: Direction})
    direction: number = Direction.HORIZONTAL

    @property(cc.Float)
    brake: number = 0.03

    @property({type: [cc.Component.EventHandler]})
    scrollEvents: cc.Component.EventHandler[] = []

    private _v = 0
    private _preTime = 0
    private _touchMoved = false
    private _touchEnded = true

    onLoad () {
        this.node.on(cc.Node.EventType.TOUCH_START, this.onTouchStart, this, true)
        this.node.on(cc.Node.EventType.TOUCH_MOVE, this.onTouchMove, this, true)
        this.node.on(cc.Node.EventType.TOUCH_END, this.onTouchEnd, this, true)
        this.node.on(cc.Node.EventType.TOUCH_CANCEL, this.onTouchCancel, this, true)
    }

    onDestroy () {
        this.node.off(cc.Node.EventType.TOUCH_START, this.onTouchStart, this, true)
        this.node.off(cc.Node.EventType.TOUCH_MOVE, this.onTouchMove, this, true)
        this.node.off(cc.Node.EventType.TOUCH_END, this.onTouchEnd, this, true)
        this.node.off(cc.Node.EventType.TOUCH_CANCEL, this.onTouchCancel, this, true)
    }

    update (dt) {
        this.processAutoScrolling(dt)
    }

    onTouchStart (event: cc.Event.EventTouch) {
        this._v = 0
        this._touchMoved = false
        this._touchEnded = false
        cc.Component.EventHandler.emitEvents(this.scrollEvents, this, EventType.SCROLL_BEGAN)
    }

    onTouchMove (event: cc.Event.EventTouch) {
        // 小于滑动区则不能滑动
        if ((this.direction === Direction.HORIZONTAL && this.content.width < this.node.width) || (this.direction === Direction.VERTICAL && this.content.height < this.node.height)) {
            return
        }

        // 计算初速度
        let s = this.direction === Direction.HORIZONTAL ? event.getDeltaX() : event.getDeltaY()
        if (this._preTime !== 0) {
            let t = ((new Date().getTime()) - this._preTime) / 1000
            t = t < 0.00001 ? (1 / 60) : t
            this._v = s / t
        }
        
        this.direction === Direction.HORIZONTAL ? this.setContentPosition(cc.v2(this.content.x + s, this.content.y)) : this.setContentPosition(cc.v2(this.content.x, this.content.y + s))
        cc.Component.EventHandler.emitEvents(this.scrollEvents, this, EventType.SCROLLING)
        this._preTime = new Date().getTime()

        // 滑动超过一段距离，判断为滑动
        let deltaMove = event.touch.getLocation().sub(event.touch.getStartLocation())
        if (deltaMove.mag() > 7) {
            this._touchMoved = true
        }
    }

    onTouchCancel (event: cc.Event.EventTouch) {
        this._touchEnded = true
        this._preTime = 0
        cc.Component.EventHandler.emitEvents(this.scrollEvents, this, EventType.TOUCH_UP)
    }

    onTouchEnd (event: cc.Event.EventTouch) {
        this._touchEnded = true
        this._preTime = 0
        cc.Component.EventHandler.emitEvents(this.scrollEvents, this, EventType.TOUCH_UP)

        // 不再让子节点获取触摸事件
        if (this._touchMoved) {
            event.stopPropagation();
        }
    }

    setContentPosition (newPosition: cc.Vec2) {
        this.content.position = newPosition

        if (this.direction === Direction.HORIZONTAL) {
            let contentLeft = this.node.convertToNodeSpaceAR(this.content.convertToWorldSpaceAR(cc.v2(-this.content.width * this.content.anchorX, 0))).x
            let selfLeft = -this.node.width * this.node.anchorX

            if (contentLeft > selfLeft) {
                this.content.x = this.content.parent.convertToNodeSpaceAR(this.node.convertToWorldSpaceAR(cc.v2(selfLeft, 0))).x + this.content.width * this.content.anchorX
                cc.Component.EventHandler.emitEvents(this.scrollEvents, this, EventType.SCROLL_TO_LEFT)
            }else {
                let contentRight = contentLeft + this.content.width
                let selfRight = selfLeft + this.node.width

                if (contentRight < selfRight) {
                    this.content.x = this.content.parent.convertToNodeSpaceAR(this.node.convertToWorldSpaceAR(cc.v2(selfRight, 0))).x - this.content.width * (1 - this.content.anchorX)
                    cc.Component.EventHandler.emitEvents(this.scrollEvents, this, EventType.SCROLL_TO_RIGHT)
                }
            }
        }else if (this.direction === Direction.VERTICAL) {
            let contentBottom = this.node.convertToNodeSpaceAR(this.content.convertToWorldSpaceAR(cc.v2(0, -this.content.height * this.content.anchorY))).y
            let selfBottom = -this.node.height * this.node.anchorY

            if (contentBottom > selfBottom) {
                this.content.y = this.content.parent.convertToNodeSpaceAR(this.node.convertToWorldSpaceAR(cc.v2(0, selfBottom))).y + this.content.height * this.content.anchorY
                cc.Component.EventHandler.emitEvents(this.scrollEvents, this, EventType.SCROLL_TO_BOTTOM)
            }else {
                let contentTop = contentBottom + this.content.height
                let selfTop = selfBottom + this.node.height

                if (contentTop < selfTop) {
                    this.content.y = this.content.parent.convertToNodeSpaceAR(this.node.convertToWorldSpaceAR(cc.v2(0, selfTop))).y - this.content.height * (1 - this.content.anchorY)
                    cc.Component.EventHandler.emitEvents(this.scrollEvents, this, EventType.SCROLL_TO_TOP)
                }
            }
        }
    }

    stopAutoScroll () {
        this._v = 0
        cc.Component.EventHandler.emitEvents(this.scrollEvents, this, EventType.SCROLL_ENDED)
    }

    private processAutoScrolling (dt) {
        if (this._touchEnded && this._v !== 0) {
            let s = this._v * dt
            this._v = this._v * (1 - this.brake)

            if (Math.abs(s) > 2) {
                this.direction === Direction.HORIZONTAL ? this.setContentPosition(cc.v2(this.content.x + s, this.content.y)) : this.setContentPosition(cc.v2(this.content.x, this.content.y + s))
                cc.Component.EventHandler.emitEvents(this.scrollEvents, this, EventType.SCROLLING)
            }else {
                this.stopAutoScroll()
            }
        }
    }
}
